import { Icon, IconGroup } from 'semantic-ui-react'
import { Option } from '../Option'
import RequestCourier from '../../../RequestCouriers'
import { useContext } from 'react'
import { UltyModalWrapperContext } from '../../../../../Shared/UltyModalWrapper/UltyModalWrapperContext'
import { useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom-v5-compat'

const AddCourier = () => {
    const params = useParams()
    const id = +params.id
    const [t] = useTranslation()
    const queryClient = useQueryClient()
    const {handleUltyModalWrapper} = useContext(UltyModalWrapperContext)

    const order = queryClient.getQueryData(['orders', id])

    const handleUpdateCourier = async (order) => {
        const modalSettings = {
            title: `${t('order.couriers.title')}`,
            component: <RequestCourier
              order={order}
              afterSubmit={async () => {
                  await queryClient.invalidateQueries({queryKey: ['orders', id]})
                  handleUltyModalWrapper(false)
              }}/>,
        }
        handleUltyModalWrapper(true, modalSettings)
    }

    return (
      <Option
        onClick={() => handleUpdateCourier(order)}
      >
          <IconGroup>
              <Icon name="user" color="teal"/>
              <Icon corner name="add" color="grey"/>
          </IconGroup>
          <p>{t('order.add_couriers')}</p>
      </Option>
    )
}

export { AddCourier }
